import { createWithdrawReducer } from '@ppay/client'

import { createMerchantFiatWithdrawAction } from '../../../actions'

export const createFiatWithdraw = createWithdrawReducer(createMerchantFiatWithdrawAction)
